module.exports = __webpack_public_path__ + "assets/img/kariakin.8e5c94b0.webp";